import {useQuery} from 'react-query'
import {TourEditModalForm} from './TourEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_dashboard/helpers'
import {useListView} from '../core/ListViewProvider'
import { getOneById } from '../../../../services/common_requests'

const TourEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: tour,
    error,
  } = useQuery(
    `${(QUERIES as any).TOURS_LIST}-tour-${itemIdForUpdate}`,
    () => {
      return getOneById(itemIdForUpdate, "/tours")
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return null // No form if no item selected
  }

  if (!isLoading && !error && tour) {
    return <TourEditModalForm isTourLoading={isLoading} tour={tour} />
  }

  return null
}

export {TourEditModalFormWrapper}
